import JsxComponent from '@slickdeals/blueprint-twig/javascript/core/jsxComponent';
import Image from '@slickdeals/blueprint-twig/javascript/components/image';
export const name = 'CashbackWelcomeModal';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-p-cashbackWelcomeModal";
    ClassNames["PrimaryButton"] = "bp-p-cashbackWelcomeModal_primaryButton";
    ClassNames["SecondaryButton"] = "bp-p-cashbackWelcomeModal_secondaryButton";
})(ClassNames || (ClassNames = {}));
class CashbackWelcomeModal extends JsxComponent {
    constructor() {
        super(name);
    }
    /**
     * Creates the main welcome modal UI
     *
     * @returns HTMLDivElement
     */
    createElement() {
        // NOTE: data is hardcoded for the time being until there is a need to abstract it out
        const data = [
            {
                'imgSrc': '/image-pool/loyalty/no-extension/DealTile.svg',
                'imgAlt': 'Deal tile graphic',
                'primaryText': 'Business as Usual',
                'secondaryText': 'Shop for great deals on Slickdeals.',
            },
            {
                'imgSrc': '/image-pool/loyalty/no-extension/CBPopUp.svg',
                'imgAlt': 'Cashback pop up graphic',
                'primaryText': 'Earn Points',
                'secondaryText': 'Look for Cashback on deals, follow instructions and earn Rewards Points!',
            },
            {
                'imgSrc': '/image-pool/loyalty/no-extension/MoneyJar.svg',
                'imgAlt': 'Money jar graphic',
                'primaryText': 'Oh, The Anticipation',
                'secondaryText': 'Check the Rewards Portal for your Points balance.',
            },
            {
                'imgSrc': '/image-pool/loyalty/no-extension/GiftCards.svg',
                'imgAlt': 'Gift card graphic',
                'primaryText': 'Cash Out',
                'secondaryText': 'Redeem Points for gift cards or PayPal credit.',
            },
        ];
        const list = this.createList(data);
        const rightColumnImage = Image.createElement({
            'src': '/image-pool/loyalty/no-extension/RewardsCoinIllustration.svg',
        });
        rightColumnImage.alt = 'Illustration of person holding gold coins.';
        rightColumnImage.classList.add('bp-p-cashbackWelcomeModal_rightImg');
        return (JsxComponent.parseJsx("div", { className: "bp-p-cashbackWelcomeModal" },
            JsxComponent.parseJsx("div", { className: "bp-p-cashbackWelcomeModal_left" }, list),
            JsxComponent.parseJsx("div", { className: "bp-p-cashbackWelcomeModal_right" }, rightColumnImage),
            JsxComponent.parseJsx("footer", { className: "bp-p-cashbackWelcomeModal_footer" },
                JsxComponent.parseJsx("button", { className: "bp-p-cashbackWelcomeModal_secondaryButton" }, "Return to Deal Details"),
                JsxComponent.parseJsx("button", { className: "bp-p-cashbackWelcomeModal_primaryButton" }, "Go Get This Deal"))));
    }
    /**
     * Creates left list UI within welcome modal
     *
     * @param data An array of images and their data
     * @returns The HTML List element as a fragment
     */
    createList(data) {
        const listItems = data.map((step, index) => {
            const listItemImage = Image.createElement({
                'src': step.imgSrc,
            });
            listItemImage.alt = step.imgAlt;
            listItemImage.classList.add('bp-p-cashbackWelcomeModal_leftListItemImg');
            return (JsxComponent.parseJsx("li", { className: "bp-p-cashbackWelcomeModal_leftListItem" },
                listItemImage,
                JsxComponent.parseJsx("span", { className: "bp-p-cashbackWelcomeModal_leftListItemNumber" },
                    index + 1,
                    "."),
                JsxComponent.parseJsx("p", { className: "bp-p-cashbackWelcomeModal_leftListItemDetail" },
                    JsxComponent.parseJsx("strong", null, step.primaryText),
                    JsxComponent.parseJsx("br", null),
                    step.secondaryText)));
        });
        return (JsxComponent.parseJsx("fragment", null,
            JsxComponent.parseJsx("h2", { className: "bp-p-cashbackWelcomeModal_leftHeading" }, "Welcome to Slickdeals Rewards!"),
            JsxComponent.parseJsx("p", { className: "bp-p-cashbackWelcomeModal_leftSubheading" }, "Earning Rewards Points (Cashback) is easy:"),
            JsxComponent.parseJsx("ul", { className: "bp-p-cashbackWelcomeModal_leftList" }, listItems)));
    }
}
export default CashbackWelcomeModal;
